import React from 'react';

import {
  Container,
  CenterContainer,
  MediaContainer,
  EndContainer,
  CollectionTitle,
  Title,
  Vendor,
  ButtonLink,
  ButtonLinkCart,
  QuantityInput,
  Price,
} from './LineItemView.styles';
import Media from './Media';
import RemoveButtonIcon from './RemoveIcon';
import SelectedOptions from './SelectedOptions';

function LineItemView({
  children,
  ...props
}: React.PropsWithChildren<React.HTMLAttributes<HTMLDivElement>>): JSX.Element {
  return <Container {...props}>{children}</Container>;
}

LineItemView.MediaContainer = MediaContainer;
LineItemView.Media = Media;
LineItemView.CenterContainer = CenterContainer;
LineItemView.EndContainer = EndContainer;
LineItemView.CollectionTitle = CollectionTitle;
LineItemView.Title = Title;
LineItemView.Vendor = Vendor;
LineItemView.Price = Price;
LineItemView.SelectedOptions = SelectedOptions;
LineItemView.QuantityInput = QuantityInput;
LineItemView.ButtonLink = ButtonLink;
LineItemView.ButtonLinkCart = ButtonLinkCart;
LineItemView.RemoveButtonIcon = RemoveButtonIcon;

LineItemView.defaultProps = {
  withRemoveButtonIcon: true,
};

export default LineItemView;
